import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoTablet = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Tablet</title>
    <rect x={6.742} y={3.667} width={18.514} height={24.667} rx={1.286} stroke="currentColor" strokeWidth={2} />
    <path stroke="currentColor" strokeWidth={2} strokeLinecap="round" d="M14.34 25.217h3.316" />
  </svg>
);
export default SvgIcoTablet;
